import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";

import { HexAccordionModule } from "@hex/angular/accordion";
import { HexDataListModule } from "@hex/angular/data-list";

import { CommonStaticFilterModule } from "../common-static-filter/common-static-filter.module";
import { CommonUtilsModule } from "../common-utils/common-utils.module";
import { SectionsModule } from "../presentational/sections/sections.module";
import { RowSelectionModule } from "../row-selection/row-selection.module";
import { CommonAccordionComponent } from "./accordion/common-accordion.component";
import { CommonListActionsDirective } from "./actions.directive";
import { CommonDatalistComponent } from "./datalist/common-datalist.component";
import { CommonPlainListComponent } from "./plain-list/common-plain-list.component";

import { accordionListStatePropProvider, datalistStatePropProvider, plainListStatePropProvider } from "./state-props";

@NgModule({
    imports: [
        CommonModule,
        HexAccordionModule,
        HexDataListModule,
        CommonStaticFilterModule,
        CommonUtilsModule,
        RowSelectionModule,
        SectionsModule,
    ],
    exports: [
        ...[
            CommonAccordionComponent,
            CommonDatalistComponent,
            CommonPlainListComponent,
            CommonListActionsDirective,
        ],
        HexDataListModule,
        CommonUtilsModule,
    ],
    declarations: [
        CommonAccordionComponent,
        CommonDatalistComponent,
        CommonPlainListComponent,
        CommonListActionsDirective,
    ],
    providers: [
        CommonListActionsDirective,
        accordionListStatePropProvider,
        datalistStatePropProvider,
        plainListStatePropProvider,
    ],
})
export class CommonListModule {
}
